<template>
  <div class="product-purchase-inbound-root">
    <div class="statistics-container no-print">
    <div class="page-header">
      <div class="header-title">
        <div class="title-mark"></div>
        <span>商品入库明细表</span>
      </div>
    </div>

    <div class="search-area">
      <el-date-picker
        v-model="startDate"
        type="date"
        placeholder="入库开始日期"
        value-format="yyyy-MM-dd"
        class="search-input date-picker-single"
      ></el-date-picker>
      <el-date-picker
        v-model="endDate"
        type="date"
        placeholder="入库结束日期"
        value-format="yyyy-MM-dd"
        class="search-input date-picker-single"
      ></el-date-picker>

      <el-select
        v-model="selectedSupplierNames"
        multiple
        filterable
        placeholder="供货单位名称（多选）"
        class="search-input select-multi"
        clearable
      >
        <el-option
          v-for="item in supplierNameOptions"
          :key="item"
          :label="item"
          :value="item"
        ></el-option>
      </el-select>

      <el-input
        v-model="warehouseNameFilter"
        placeholder="库房名称"
        clearable
        class="search-input warehouse-name-input"
        @keyup.enter.native="handleSearch"
      ></el-input>

      <el-button type="primary" @click="handleSearch" icon="el-icon-search">搜索</el-button>
      <el-button @click="handleReset" icon="el-icon-refresh">重置</el-button>
      <el-button
        v-permission="'product:purchase-inbound-detail:export'"
        type="warning"
        @click="handleExport"
        icon="el-icon-download"
        :loading="exportLoading"
        >导出</el-button
      >
      <el-button
        v-permission="'product:purchase-inbound-detail:print'"
        plain
        type="primary"
        @click="handlePrint"
        icon="el-icon-printer"
        :loading="printLoading"
        >打印</el-button
      >
    </div>

    <div class="table-area">
      <el-table
        :data="tableData"
        border
        stripe
        show-summary
        :summary-method="summaryMethod"
        style="width: 100%"
        v-loading="loading"
        :header-cell-style="{ background: '#f5f7fa', color: '#606266' }"
      >
        <el-table-column
          prop="inboundTime"
          label="入库时间"
          min-width="128"
          align="center"
        >
          <template slot-scope="scope">
            {{ formatInboundDate(scope.row.inboundTime) }}
          </template>
        </el-table-column>

        <el-table-column
          prop="warehouseName"
          label="库房名称"
          min-width="140"
          align="center"
          show-overflow-tooltip
        ></el-table-column>

        <el-table-column
          prop="productName"
          label="材料名称"
          min-width="140"
          align="center"
          show-overflow-tooltip
        ></el-table-column>

        <el-table-column
          prop="specification"
          label="规格型号"
          min-width="120"
          align="center"
          show-overflow-tooltip
        ></el-table-column>

        <el-table-column
          prop="materialRequirement"
          label="材质要求"
          min-width="140"
          align="center"
          show-overflow-tooltip
        ></el-table-column>

        <el-table-column prop="unit" label="单位" width="88" align="center"></el-table-column>

        <el-table-column prop="unitPriceWithTax" label="含税单价" width="118" align="center">
          <template slot-scope="scope">
            {{ formatAmount(scope.row.unitPriceWithTax) }}
          </template>
        </el-table-column>

        <el-table-column prop="unitPriceWithoutTax" label="不含税单价" width="118" align="center">
          <template slot-scope="scope">
            {{ formatAmount(scope.row.unitPriceWithoutTax) }}
          </template>
        </el-table-column>

          <el-table-column label="本期入库" align="center">
          <el-table-column prop="inboundQuantity" label="数量" width="120" align="center">
            <template slot-scope="scope">
              {{ formatQuantity(scope.row.inboundQuantity) }}
            </template>
          </el-table-column>
          <el-table-column prop="inboundAmountWithTax" label="金额(含税)" width="130" align="center">
            <template slot-scope="scope">
              {{ formatAmount(scope.row.inboundAmountWithTax) }}
            </template>
          </el-table-column>
          <el-table-column prop="inboundAmountWithoutTax" label="金额(不含税)" width="138" align="center">
            <template slot-scope="scope">
              {{ formatAmount(scope.row.inboundAmountWithoutTax) }}
            </template>
          </el-table-column>
          <el-table-column prop="procurementManagementFee" label="采管费金额" width="120" align="center">
            <template slot-scope="scope">
              {{ formatAmount(scope.row.procurementManagementFee) }}
            </template>
          </el-table-column>
        </el-table-column>

        <el-table-column
          prop="supplierUnitName"
          label="供货单位"
          min-width="140"
          align="center"
          show-overflow-tooltip
        ></el-table-column>
      </el-table>

      <div class="pagination-container">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pagination.currentPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="pagination.pageSize"
          layout="prev, pager, next, jumper, sizes, total"
          :total="pagination.total"
        >
        </el-pagination>
      </div>
    </div>
    </div>

    <div class="no-print">
      <el-dialog
        title="选择审核人"
        :visible.sync="auditorDialogVisible"
        width="460px"
        :close-on-click-modal="false"
      >
        <el-form label-width="90px">
          <el-form-item label="审核人">
            <el-select
              v-model="selectedAuditorId"
              placeholder="请选择本单位审核人"
              filterable
              :loading="auditorListLoading"
              loading-text="正在查询本单位用户..."
              style="width: 100%"
            >
              <el-option
                v-for="user in auditorList"
                :key="user.id || user.userId"
                :label="`${user.username || user.realName || '未命名用户'}${user.signatureImagePath || user.signature_image_path ? '' : '（未上传签名）'}`"
                :value="user.id || user.userId"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <el-button @click="auditorDialogVisible = false">取消</el-button>
          <el-button type="primary" :loading="auditorConfirmLoading" @click="confirmPrint">确认打印</el-button>
        </div>
      </el-dialog>
    </div>

    <!-- 仅用于打印，勿置于 .no-print 内 -->
    <div ref="printSheet" class="inbound-print-sheet product-detail-print-sheet-root">
      <div class="ipc-company-line">{{ warehouseUnitDisplay }}</div>
      <div class="ipc-title-line">商品入库明细表</div>
      <div class="ipc-meta-line">
        <span class="ipc-meta-left">库房单位：{{ warehouseUnitDisplay }}</span>
        <span class="ipc-meta-center">{{ printPeriodLabel }}</span>
        <span class="ipc-meta-right">单位：元</span>
      </div>
      <table class="ipc-table" border="1" cellspacing="0" cellpadding="0">
        <thead>
          <tr>
            <th rowspan="2">入库时间</th>
            <th rowspan="2">库房名称</th>
            <th rowspan="2">材料名称</th>
            <th rowspan="2">规格型号</th>
            <th rowspan="2">材质要求</th>
            <th rowspan="2">单位</th>
            <th rowspan="2">含税单价</th>
            <th rowspan="2">不含税单价</th>
            <th colspan="4" class="ipc-th-group">本期入库</th>
            <th rowspan="2">供货单位</th>
          </tr>
          <tr>
            <th>数量</th>
            <th>金额（含税）</th>
            <th>金额（不含税）</th>
            <th>采管费金额</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, idx) in printTableRows" :key="'p' + idx">
            <td>{{ formatInboundDate(row.inboundTime) }}</td>
            <td class="ipc-td-text">{{ row.warehouseName || '' }}</td>
            <td class="ipc-td-text">{{ row.productName || '' }}</td>
            <td class="ipc-td-text">{{ row.specification || '' }}</td>
            <td class="ipc-td-text">{{ row.materialRequirement || '' }}</td>
            <td>{{ row.unit || '' }}</td>
            <td class="ipc-td-num">{{ formatAmount(row.unitPriceWithTax) }}</td>
            <td class="ipc-td-num">{{ formatAmount(row.unitPriceWithoutTax) }}</td>
            <td class="ipc-td-num">{{ formatQtyPrint(row.inboundQuantity) }}</td>
            <td class="ipc-td-num">{{ formatAmount(row.inboundAmountWithTax) }}</td>
            <td class="ipc-td-num">{{ formatAmount(row.inboundAmountWithoutTax) }}</td>
            <td class="ipc-td-num">{{ formatAmount(row.procurementManagementFee) }}</td>
            <td class="ipc-td-text">{{ row.supplierUnitName || '' }}</td>
          </tr>
        </tbody>
        <tfoot v-if="printSummaryTotals">
          <tr>
            <td colspan="8" class="ipc-tfoot-label">合计</td>
            <td class="ipc-td-num">{{ formatQtyPrint(printSummaryTotals.inboundQuantitySum) }}</td>
            <td class="ipc-td-num">{{ formatAmount(printSummaryTotals.inboundAmountWithTaxSum) }}</td>
            <td class="ipc-td-num">{{ formatAmount(printSummaryTotals.inboundAmountWithoutTaxSum) }}</td>
            <td class="ipc-td-num">{{ formatAmount(printSummaryTotals.procurementManagementFeeSum) }}</td>
            <td></td>
          </tr>
        </tfoot>
      </table>
      <div class="ipc-sign-row">
        <span class="ipc-auditor-signature">
          审核人：
          <img v-if="currentAuditorSignatureUrl" :src="currentAuditorSignatureUrl" alt="审核人签名" />
          <span v-else>__________________</span>
        </span>
        <span class="ipc-operator-signature">
          经办人：
          <img v-if="currentUserSignatureUrl" :src="currentUserSignatureUrl" alt="签名" />
          <span v-else>__________________</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { query_user_by_id } from '@/api/modules/user'
import { getUsersByUnitId } from '@/api/modules/users'
import { mapGetters } from 'vuex'
import { buildPrintDocumentKey, installPlatformPrintFooter } from '@/utils/print-footer'
import { getApiUrl } from '@/utils/env'

export default {
  name: 'ProductPurchaseInboundDetail',

  data() {
    return {
      /** 入库起止日期 yyyy-MM-dd */
      startDate: '',
      endDate: '',
      selectedSupplierNames: [],
      supplierNameOptions: [],
      /** 库房名称模糊查询 */
      warehouseNameFilter: '',
      loading: false,
      exportLoading: false,
      printLoading: false,
      tableData: [],
      summaryTotals: null,
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      /** 打印用全量行（与导出一致逻辑） */
      printTableRows: [],
      printSummaryTotals: null,
      printOperatorSignatureUrl: null,
      printAuditorSignatureUrl: null,
      auditorDialogVisible: false,
      auditorList: [],
      auditorListLoading: false,
      auditorConfirmLoading: false,
      selectedAuditorId: null
    }
  },

  computed: {
    ...mapGetters(['userInfo']),
    warehouseUnitDisplay() {
      const u = this.userInfo
      if (!u) return ''
      return (u.unitName || u.unit_name || '').trim()
    },
    currentUserSignatureUrl() {
      const u = this.userInfo || {}
      return this.printOperatorSignatureUrl || this.buildSignatureImageUrl(u.signatureImagePath || u.signature_image_path)
    },
    currentAuditorSignatureUrl() {
      return this.printAuditorSignatureUrl
    },
    /** 抬头期间：精确到日；未选日期时为「全部期间」 */
    printPeriodLabel() {
      if (!this.startDate && !this.endDate) {
        return '全部期间'
      }
      const a = this.startDate || ''
      const b = this.endDate || ''
      if (a && b) return `${a} ~ ${b}`
      if (a) return `${a} 起`
      return `至 ${b}`
    }
  },

  created() {
    this._boundAfterPrint = () => {
      this.detachPrintSheetFromBody()
    }
    this.loadFilterOptions()
    this.loadData()
  },

  beforeDestroy() {
    window.removeEventListener('afterprint', this._boundAfterPrint)
    this.detachPrintSheetFromBody()
  },

  methods: {
    loadFilterOptions() {
      api.contracts
        .query_purchase_contracts_pagination({ page: 1, size: 500 })
        .then((response) => {
          if (response.data && response.data.success) {
            const content = response.data.data?.content || []
            const supplierNames = new Set()
            content.forEach((item) => {
              const names = this.extractSupplierNames(item.contractParties)
              names.forEach((n) => supplierNames.add(n))
            })
            this.supplierNameOptions = [...supplierNames].filter(Boolean).sort()
          }
        })
        .catch(() => {})
    },

    extractSupplierNames(contractParties) {
      if (!contractParties || !Array.isArray(contractParties)) return []
      const names = []
      contractParties.filter((p) => p.partyType === 'SUPPLIER').forEach((party) => {
        const name = party.unitInfo?.unitName || party.unitInfo?.name
        if (name) names.push(name)
      })
      return names
    },

    handleSearch() {
      this.pagination.currentPage = 1
      this.loadData()
    },

    handleReset() {
      this.startDate = ''
      this.endDate = ''
      this.selectedSupplierNames = []
      this.warehouseNameFilter = ''
      this.pagination.currentPage = 1
      this.loadData()
    },

    handleSizeChange(val) {
      this.pagination.pageSize = val
      this.pagination.currentPage = 1
      this.loadData()
    },

    handleCurrentChange(val) {
      this.pagination.currentPage = val
      this.loadData()
    },

    handleExport() {
      this.exportLoading = true
      const params = {}
      this.applyInboundDateParams(params)
      this.applyWarehouseNameParam(params)
      if (this.selectedSupplierNames && this.selectedSupplierNames.length > 0) {
        params.supplierUnitNames = this.selectedSupplierNames
      }
      api.statistics
        .exportProductPurchaseInboundDetail(params)
        .then((response) => {
          const blob = new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
          })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          const contentDisposition = response.headers['content-disposition']
          let fileName = '商品入库明细表.xlsx'
          if (contentDisposition) {
            const match = contentDisposition.match(/filename\*?=([^;]+)/i)
            if (match) {
              fileName = decodeURIComponent(match[1].replace(/^UTF-8''/, '').trim())
            }
          }
          link.download = fileName
          document.body.appendChild(link)
          link.click()
          document.body.removeChild(link)
          window.URL.revokeObjectURL(url)
          this.$message.success('导出成功')
        })
        .catch((err) => {
          this.$message.error(err.response?.data?.message || '导出失败')
        })
        .finally(() => {
          this.exportLoading = false
        })
    },

    async handlePrint() {
      this.selectedAuditorId = null
      this.printAuditorSignatureUrl = null
      this.auditorDialogVisible = true
      this.auditorListLoading = true
      try {
        const currentUser = this.userInfo || {}
        const unitId = currentUser.unitId ?? currentUser.unit_id
        const currentUserId = currentUser.userId ?? currentUser.id ?? currentUser.user_id
        if (!unitId) {
          throw new Error('当前用户没有所属单位，无法选择审核人')
        }

        const response = await getUsersByUnitId(unitId)
        if (!response.data || !response.data.success) {
          throw new Error(response.data?.message || '获取本单位用户失败')
        }
        this.auditorList = (response.data.data || []).filter((user) => {
          const userId = user.id ?? user.userId
          return String(userId) !== String(currentUserId)
        })
        if (!this.auditorList.length) {
          this.auditorDialogVisible = false
          this.$message.warning('本单位没有其他用户可以作为审核人')
        }
      } catch (error) {
        this.auditorDialogVisible = false
        this.$message.error(error.message || '获取审核人列表失败')
      } finally {
        this.auditorListLoading = false
      }
    },

    async confirmPrint() {
      if (!this.selectedAuditorId) {
        this.$message.warning('请选择审核人')
        return
      }
      const selectedAuditor = this.auditorList.find((user) => {
        return String(user.id ?? user.userId) === String(this.selectedAuditorId)
      })
      if (!selectedAuditor) {
        this.$message.warning('审核人信息已失效，请重新选择')
        return
      }

      this.auditorConfirmLoading = true
      try {
        let auditor = selectedAuditor
        const response = await query_user_by_id(this.selectedAuditorId)
        if (response.data && response.data.success && response.data.data) {
          auditor = response.data.data
        }
        const signaturePath = auditor.signatureImagePath || auditor.signature_image_path
        if (!signaturePath) {
          this.$message.warning('该用户未上传签名图片，请选择已上传签名的用户')
          return
        }
        this.printAuditorSignatureUrl = this.buildSignatureImageUrl(signaturePath)
        this.auditorDialogVisible = false
        this.startPrint()
      } catch (error) {
        this.$message.error(error.response?.data?.message || error.message || '获取审核人签名失败')
      } finally {
        this.auditorConfirmLoading = false
      }
    },

    startPrint() {
      this.printLoading = true
      /* 避免上次 afterprint 未触发时 printAttached 卡住；并收回可能留在 body 上的打印层 */
      window.removeEventListener('afterprint', this._boundAfterPrint)
      this.detachPrintSheetFromBody()
      const params = {
        page: 0,
        size: 50000
      }
      this.applyInboundDateParams(params)
      this.applyWarehouseNameParam(params)
      if (this.selectedSupplierNames && this.selectedSupplierNames.length > 0) {
        params.supplierUnitNames = this.selectedSupplierNames
      }
      Promise.resolve()
        .then(() => this.loadCurrentUserSignature())
        .then(() => api.statistics.getProductPurchaseInboundDetail(params))
        .then((response) => {
          if (!response.data || !response.data.success) {
            this.$message.error(response.data?.message || '加载打印数据失败')
            throw new Error('print_skip')
          }
          const data = response.data.data || {}
          const rows = data.content || []
          if (!rows.length) {
            this.$message.warning('当前条件下没有可打印的数据')
            throw new Error('print_skip')
          }
          this.printTableRows = rows
          this.printSummaryTotals = data.totals || null
        })
        .then(() => this.$nextTick())
        .then(() => {
          this.attachPrintSheetToBody()
          return this.$nextTick()
        })
        .then(async () => {
          window.addEventListener('afterprint', this._boundAfterPrint, { once: true })
          /* 浏览器页眉常取 document.title；临时改为报表名，避免显示 supplychain-frontend 等工程名 */
          this._printDocumentTitleBackup = document.title
          document.title = '商品入库明细表'
          await installPlatformPrintFooter(window, this.$refs.printSheet, {
            documentType: 'PRODUCT_PURCHASE_INBOUND',
            documentKey: buildPrintDocumentKey(
              this.startDate,
              this.endDate,
              this.warehouseNameFilter,
              this.selectedSupplierNames
            )
          })
          await this.waitForPrintImages()
          window.print()
        })
        .catch((err) => {
          if (err && err.message === 'print_skip') return
          if (err && err.response) {
            this.$message.error(err.response?.data?.message || '加载打印数据失败')
          }
        })
        .finally(() => {
          this.printLoading = false
        })
    },

    /** 将起止日期应用到接口参数 */
    applyInboundDateParams(params) {
      if (this.startDate) params.startDate = this.startDate
      if (this.endDate) params.endDate = this.endDate
    },

    applyWarehouseNameParam(params) {
      const w = (this.warehouseNameFilter || '').trim()
      if (w) params.warehouseName = w
    },

    buildSignatureImageUrl(filePath) {
      if (!filePath) return null
      if (/^(https?:\/\/|data:)/.test(filePath)) return filePath
      return `${getApiUrl('/attachments/download')}?filePath=${encodeURIComponent(filePath)}`
    },

    async loadCurrentUserSignature() {
      const cachedUser = this.userInfo || {}
      const cachedPath = cachedUser.signatureImagePath || cachedUser.signature_image_path
      this.printOperatorSignatureUrl = this.buildSignatureImageUrl(cachedPath)
      const userId = cachedUser.userId || cachedUser.id || cachedUser.user_id
      if (!userId) return

      try {
        const response = await query_user_by_id(userId)
        const user = response.data && response.data.success ? response.data.data : null
        if (user) {
          this.printOperatorSignatureUrl = this.buildSignatureImageUrl(
            user.signatureImagePath || user.signature_image_path
          )
        }
      } catch (error) {
        console.warn('获取当前用户签名图片失败，使用缓存签名:', error)
      }
    },

    waitForPrintImages() {
      const sheet = this.$refs.printSheet
      const images = sheet ? Array.from(sheet.querySelectorAll('img')) : []
      return Promise.all(images.map((image) => {
        if (image.complete) return Promise.resolve()
        return new Promise((resolve) => {
          let settled = false
          const done = () => {
            if (settled) return
            settled = true
            resolve()
          }
          image.addEventListener('load', done, { once: true })
          image.addEventListener('error', done, { once: true })
          setTimeout(done, 5000)
        })
      }))
    },

    attachPrintSheetToBody() {
      const sheet = this.$refs.printSheet
      if (!sheet) return
      document.querySelectorAll('body > .product-detail-print-sheet-root').forEach((el) => {
        if (el !== sheet) {
          el.remove()
        }
      })
      if (sheet.parentNode === document.body) {
        sheet.dataset.printAttached = '1'
        return
      }
      this._printSheetStash = {
        parent: sheet.parentNode,
        next: sheet.nextSibling
      }
      sheet.dataset.printAttached = '1'
      document.body.appendChild(sheet)
    },

    detachPrintSheetFromBody() {
      if (this._printDocumentTitleBackup != null) {
        document.title = this._printDocumentTitleBackup
        this._printDocumentTitleBackup = null
      }

      const sheet = this.$refs.printSheet
      if (!sheet || sheet.dataset.printAttached !== '1') return

      delete sheet.dataset.printAttached
      const stash = this._printSheetStash
      this._printSheetStash = null

      let restored = false
      if (stash && stash.parent && stash.parent.nodeType === 1 && document.documentElement.contains(stash.parent)) {
        try {
          if (stash.next && stash.next.parentNode === stash.parent) {
            stash.parent.insertBefore(sheet, stash.next)
          } else {
            stash.parent.appendChild(sheet)
          }
          restored = true
        } catch (e) {
          void 0
        }
      }
      if (!restored && this.$el && this.$el.nodeType === 1) {
        try {
          this.$el.appendChild(sheet)
          restored = true
        } catch (e2) {
          void 0
        }
      }
      if (!restored) {
        sheet.remove()
      }
    },

    /** 打印表数量列：两位小数（与范例一致） */
    formatQtyPrint(q) {
      if (q === undefined || q === null) return '0.00'
      const fixed = Number(q).toFixed(2)
      const [intPart, fracPart] = fixed.split('.')
      const intFmt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return fracPart !== undefined ? `${intFmt}.${fracPart}` : intFmt
    },

    formatInboundDate(v) {
      if (v === undefined || v === null || v === '') return ''
      const s = String(v)
      const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/)
      if (m) {
        return `${m[1]}年${parseInt(m[2], 10)}月${parseInt(m[3], 10)}日`
      }
      const m2 = s.match(/(\d{4})-(\d{2})-(\d{2})T/)
      if (m2) {
        return `${m2[1]}年${parseInt(m2[2], 10)}月${parseInt(m2[3], 10)}日`
      }
      return s
    },

    formatAmount(amount) {
      if (amount === undefined || amount === null) return '0.00'
      return Number(amount)
        .toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    formatQuantity(q) {
      if (q === undefined || q === null) return '0.0000'
      const fixed = Number(q).toFixed(4)
      const [intPart, fracPart] = fixed.split('.')
      const intFmt = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, ',')
      return fracPart !== undefined ? `${intFmt}.${fracPart}` : intFmt
    },

    summaryMethod() {
      const t = this.summaryTotals || {}
      const fmtAmt = (k) => this.formatAmount(t[k] != null ? t[k] : 0)
      const fmtQty = (k) => this.formatQuantity(t[k] != null ? t[k] : 0)
      return [
        '合计',
        '',
        '',
        '',
        '',
        '',
        '',
        '',
        fmtQty('inboundQuantitySum'),
        fmtAmt('inboundAmountWithTaxSum'),
        fmtAmt('inboundAmountWithoutTaxSum'),
        fmtAmt('procurementManagementFeeSum'),
        ''
      ]
    },

    loadData() {
      this.loading = true
      const params = {
        page: this.pagination.currentPage - 1,
        size: this.pagination.pageSize
      }
      this.applyInboundDateParams(params)
      this.applyWarehouseNameParam(params)
      if (this.selectedSupplierNames && this.selectedSupplierNames.length > 0) {
        params.supplierUnitNames = this.selectedSupplierNames
      }
      api.statistics
        .getProductPurchaseInboundDetail(params)
        .then((response) => {
          if (response.data && response.data.success) {
            const data = response.data.data || {}
            this.tableData = data.content || []
            this.pagination.total = data.totalElements || 0
            this.summaryTotals = data.totals || null
          } else {
            this.tableData = []
            this.summaryTotals = null
            this.$message.error(response.data?.message || '查询失败')
          }
        })
        .catch((err) => {
          this.tableData = []
          this.summaryTotals = null
          this.$message.error(err.response?.data?.message || '查询失败')
        })
        .finally(() => {
          this.loading = false
        })
    }
  }
}
</script>

<style lang="scss" scoped>
.statistics-container {
  padding: 20px;
}
.page-header {
  margin-bottom: 20px;
}
.header-title {
  display: flex;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  color: #303133;
}
.title-mark {
  width: 4px;
  height: 18px;
  background: #409eff;
  margin-right: 10px;
}
.search-area {
  display: flex;
  gap: 10px;
  align-items: center;
  flex-wrap: wrap;
  margin-bottom: 20px;
}
.search-input.date-picker-single {
  width: 160px;
}
.select-multi {
  min-width: 220px;
  max-width: 320px;
}
.search-input.warehouse-name-input {
  width: 200px;
}
.table-area {
  margin-bottom: 20px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}
::v-deep .el-table th {
  background-color: #f5f7fa !important;
  color: #606266 !important;
  font-weight: 600;
}
::v-deep .el-table__footer-wrapper tbody td {
  background-color: #fafafa !important;
  font-weight: 600;
}
</style>

<style lang="scss">
/* 打印区：可挂到 body，样式以 .inbound-print-sheet 为根 */
.inbound-print-sheet {
  position: absolute;
  left: -9999px;
  top: 0;
  width: 1200px;
  box-sizing: border-box;
  font-family: 'Microsoft YaHei', SimHei, sans-serif;
  color: #000;
  background: #fff;
}

.inbound-print-sheet .ipc-company-line {
  text-align: center;
  font-weight: bold;
  font-size: 16px;
  line-height: 1.4;
}

.inbound-print-sheet .ipc-title-line {
  text-align: center;
  font-weight: bold;
  font-size: 18px;
  margin: 6px 0 10px;
}

.inbound-print-sheet .ipc-meta-line {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 12px;
  margin-bottom: 10px;
}

.inbound-print-sheet .ipc-meta-left {
  flex: 0 0 auto;
}

.inbound-print-sheet .ipc-meta-center {
  flex: 1;
  text-align: center;
}

.inbound-print-sheet .ipc-meta-right {
  flex: 0 0 auto;
}

.inbound-print-sheet .ipc-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 11px;
  table-layout: fixed;
}

.inbound-print-sheet .ipc-table th,
.inbound-print-sheet .ipc-table td {
  border: 1px solid #000;
  padding: 4px 3px;
  word-break: break-all;
}

.inbound-print-sheet .ipc-table thead th {
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
}

.inbound-print-sheet .ipc-td-num {
  text-align: right;
}

.inbound-print-sheet .ipc-td-text {
  text-align: left;
}

.inbound-print-sheet .ipc-tfoot-label {
  text-align: center;
  font-weight: bold;
}

.inbound-print-sheet .ipc-sign-row {
  display: flex;
  justify-content: space-between;
  margin-top: 28px;
  padding: 0 12%;
  font-size: 13px;
}

.inbound-print-sheet .ipc-operator-signature {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.inbound-print-sheet .ipc-auditor-signature {
  display: inline-flex;
  align-items: center;
  gap: 8px;
}

.inbound-print-sheet .ipc-operator-signature img,
.inbound-print-sheet .ipc-auditor-signature img {
  max-width: 150px;
  max-height: 55px;
  object-fit: contain;
}

@media print {
  /*
   * 与商品出库明细表共用根类名：两页路由懒加载后各自的全局 print 样式会同时存在，
   * 若这里用各自独有的类做 body 子节点选择器，会先访问页的规则把另一页的打印根节点 hidden 掉。
   */
  body > *:not(.product-detail-print-sheet-root) {
    display: none !important;
  }

  .no-print {
    display: none !important;
  }

  /* 两页懒加载并存时，只带 inbound 的包不会给 outbound 根节点这一条，会导致仍落在屏外坐标 */
  .inbound-print-sheet,
  .outbound-print-sheet {
    position: static !important;
    left: auto !important;
    width: 100% !important;
    padding: 0;
    display: block !important;
    visibility: visible !important;
  }

  html,
  body {
    height: auto !important;
    margin: 0;
    padding: 0;
    background: #fff !important;
  }

  @page {
    size: landscape;
    margin: 10mm;
  }
}
</style>
